import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles: any = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(2),
      textAlign: 'left',
      color: theme.palette.text.primary,
    },
    shiftGraph: {
      marginTop: 0,
      marginLeft: 44,
    },
    header: {
      fontSize: '1.6rem',
      // fontWeight: 750,
      color: theme.palette.secondary.main,
    },
    itemTitle: {
      color: theme.palette.primary.main,
    },
    datasetHeadline: {
      color: theme.palette.secondary.main,
    },
  }),
);
